import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        meta: '主页',
        component: () => import('@/views/Home.vue'),
    },
    {
        path: '/category',
        name: 'category',
        component: () => import('@/views/Category.vue')
    },
    {
        path: '/productView/:productId',
        name: 'productView',
        component: () => import('@/views/ProductView.vue')
    },
    {
        path: '/notice',
        name: 'notice',
        component: () => import('@/views/Notice.vue'),
    },
    {
        path: '/notice/noticeView/:noticeId',
        name: 'noticeView',
        component: () => import('@/views/NoticeView.vue')
    },
    {
        path: '/search',
        name: 'search',
        component: () => import('@/views/Search.vue')
    },
    {
        path: '/404',
        name: '404',
        meta: '404',
        component: () => import('@/views/404.vue')
    },
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router
